import { Button } from 'react-bootstrap';
import { ConfirmationWrapper } from 'components/ConfirmationWrapper/ConfirmationWrapper';

export const ButtonWithConfirmation = ({
  title = <></>,
  description = '',
  className = '',
  onAction = () => {},
}) => {
  return (
    <ConfirmationWrapper description={description} onAction={onAction}>
      {(showModal) => (
        <Button className={className} onClick={showModal}>
          {title}
        </Button>
      )}
    </ConfirmationWrapper>
  );
};
